<template>
  <v-container>
    <v-card max-width="800px" v-show="!newMbr" style="margin-left: auto; margin-right: auto">
      <v-card-title>
        <span class="headline">{{ "Please log in" }}</span>
        <v-spacer></v-spacer>
        <a :href="new_mbr_url">Or click here to join!</a>
      </v-card-title>
      <v-form v-model="isValid">
        <v-card-text>
            <v-row class="xcompact">
              <v-col cols="12" sm="6">
                <v-text-field v-model="email" label="email or member number" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field :type="password" v-model="pwd" label="Password. Forgot yours? Enter FORGOT"
                              required
                              :rules="[v => !!v || 'Password is required']">
                </v-text-field>
              </v-col>
            </v-row>
            <v-btn small color="primary" dark @click="doLogIn" :disabled="!isValid">Log In</v-btn>
          <div v-show="!isValid">
            <h3>Not a member but you would like to volunteer at an event:</h3>
            Please contact the event host directly to discuss registration for an upcoming event
          </div>

          <v-row class="xcompact">
              <v-col cols="6" sm="6" md="4">
                {{ loginMsg }}
              </v-col>
            </v-row>
        </v-card-text>

      </v-form>
    </v-card>
    <br>
    <v-card max-width="800px" align="center" v-show="newMbr">
      <v-card-title>
        <span class="headline">{{ "Joining member application"}}</span>
      </v-card-title>
      <v-form v-model="nm_isValid">
        <v-card-text>
        <v-row class="xcompact">
        <v-col cols="12" sm="4">
          {{capChars}}
        </v-col>
        </v-row>
        <v-row class="xcompact">
          <v-col cols="12" sm="4">
            <v-text-field v-model="nm_captcha" label="The number of lower case letters above is"  required
                          :rules="[ countRight || 'Sorry. Try again']"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field v-model="nm_email" label="email"                              :rules="[
                                  v => !!v || 'Email is required',
                                  v => /.+@.+\.+[A-Za-z0-9\-]+/.test(v) || 'E-mail must be valid'
                                  ]">
            </v-text-field>
          </v-col>
        </v-row>
          <v-row class="xcompact">
            <v-col cols="12" sm="6">
              <v-text-field v-model="nm_fName" label="First name" required :rules="[
                      v => !!v || 'First name is required',
                      v => (v && v.length >= 3) || 'Must have 3+ characters'
                      ]"></v-text-field>

            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="nm_lName" label="Last name" required :rules="[
                      v => !!v || 'Last name is required',
                      v => (v && v.length >= 3) || 'Must have 3+ characters'
                    ]"></v-text-field>
            </v-col>
          </v-row>

          <v-row class="xcompact">
          <v-col cols="12" sm="4">
            <v-text-field v-model="nm_street" label="Street address" required :rules="[
                      v => !!v || 'Street address is required',
                      v => (v && v.length >= 3) || 'Street address must have 3+ characters'
                      ]"></v-text-field>

          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field v-model="nm_city" label="City / locality name" required :rules="[
                      v => !!v || 'City / locality is required',
                      v => (v && v.length >= 3) || 'City / locality must have 3+ characters'
                    ]"></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select v-model="nm_state" :items="this.$itmStore.states" label="State" :rules="[
                      v => !!v || 'State is required',
                      v => (v && v.length >= 2) || 'State must have 2+ characters'
                    ]"></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field v-model="nm_postalCode" label="Postal" required :rules="[
                      v => !!v || 'Postal code is required',
                      v => (v && v.length >= 4) || 'Postal code must have 4+ characters'
                    ]"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="5">
            <v-text-field :type="password" v-model="nm_pwd" label="Password"
                          required
                          :rules="[v => !!v || 'Password is required',
                            v => (v && v.length >= 8) || 'Too short. Password must have at least 8 characters',
                            v => (v && v.length <= 50) || 'Too long. Password must have at most 50 characters',
                            v => (v && /[A-Z]+/.test(v)) || 'Password must include an upper case letter',
                            v => (v && /[a-z]+/.test(v)) || 'Password must include a lower case letter',
                            v => (v && /[0-9]+/.test(v)) || 'Password must include a number',
                            v => (v && /[/,{,},!,@,#,$,%,,^,(,),<,>,.,?,+,\-,=]+/.test(v)) || 'Password must include a special character',
                           ]">
            </v-text-field>
          </v-col>

        <v-col cols="12" sm="5">
          <v-text-field :type="password" v-model="vpwd" label="Password again"
                        required
                        :rules="[ pwdSame || 'Passwords differ']">
          </v-text-field>
        </v-col>
        </v-row>
          <!--<v-btn small color="primary" dark @click="newMember" :disabled="!nm_isValid">Submit</v-btn>-->
          <v-btn small color="primary" dark @click="newMember">Submit</v-btn>
        </v-card-text>
      </v-form>
    </v-card>
  </v-container>

</template>


<script>
export default {
  name: "LogIn",
  data() {
    return {
      email: '',
      password: 'Password',
      pwd: '',
      isValid: true,

      nm_fName: '',
      nm_lName: '',
      nm_email: '',
      nm_pwd: '',
      nm_city: '',
      nm_street: '',
      nm_state: '',
      nm_country: 'AU',
      nm_postalCode: '',
      nm_phone: '',
      nm_category: 'M',
      nm_notes: '',
      active: true,
      vpwd: '',
      nm_isValid: true,
      newMbr: false,
      capChars: '',
      numLc: 0,
      nm_captcha: '',
      new_mbr_url: this.$remote+"/w3/newmember",
    }
  },
  methods: {
    countRight: function () {
      const charArr = this.capChars.trim().split(' ')
      let lc=0;
      for(let i=0; i<charArr.length; i++){
        if ((charArr[i] >='a') && (charArr[i] <='z')) {
          lc++
        }
      }
      if (this.nm_captcha == `${lc}`) {
        return true
      } else {
        this.makeQuiz()
        return false
      }
    },
    join: async function () {
      this.newMbr = true
      this.makeQuiz()
    },
    newMember: async function (e) {
      if(!this.nm_isValid) {
        alert('Please correct any flagged errors and try again')
        return
      }
      let mbr = {
        auth: this.nm_pwd,
        firstName: this.nm_fName,
        surName: this.nm_lName,
        email: this.nm_email,
        phone: this.nm_phone,
        street: this.nm_street,
        city: this.nm_city,
        state: this.nm_state,
        country: this.nm_country,
        category: this.nm_category,
      }
      let resp
      try {
        resp = await this.$http.post(this.$remote + '/api/newmbr_self', {
          mbr: mbr
        })
        if (resp.status != 200) {
          alert(`Sorry - something didn't work right.\nPlease check your answers and try again`)
          return
        }
// So far so good. Pass on to real login
        this.email = this.nm_email
        this.pwd = this.nm_pwd
        this.newMbr = false
        this.doLogIn(e)
      } catch (error) {
        alert(`Sorry - that didn't work right.\n${resp.body.message}`)
        return
      }
    },
    makeQuiz: function() {
      let ltrs='ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz0123456789'
      ltrs = ltrs + ltrs + ltrs
      let str = ''
      let lc = 0
      for (let i=0; i<12;i++){
        let c = ltrs[Math.ceil(Math.random()*10000) % ltrs.length]
        if ((c>='a') && (c <='z')) lc++
        str = str + ' '+ltrs[Math.ceil(Math.random()*10000) % ltrs.length]
      }
      this.capChars = str.trim()
      this.numLc=lc
    },
    loadRoles: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/roles', {
        token: theToken
      })
          .then(response => {
            this.$itmStore.roles = response.data.roles
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadCats: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/mbrcats', {
        token: theToken
      })
          .then(response => {
            this.$itmStore.categories = response.data.categories
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadTitles: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/titles', {
        token: theToken
      })
          .then(response => {
            this.$itmStore.titles = {}
            for (let i=0; i< response.data.titles.length; i++) {
              let title = response.data.titles[i]
              let code = title.titleCode
              this.$itmStore.titles[code] = title
            }
            this.$itmStore.titleList = response.data.titles
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadTrialTypes: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api.trial/trialtypes', {
        token: theToken
      })
          .then(response => {
            this.$itmStore.trialTypes = response.data.trial_types
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadStuff: function() {
      if(this.$itmStore.roles.length<1){
        this.loadRoles()
        console.log(this.$itmStore)
      }
      if(this.$itmStore.categories.length<1){
        this.loadCats()
        console.log(this.$itmStore)
      }
      if(!this.$itmStore.titles){
        this.loadTitles()
        console.log(this.$itmStore)
      }
      if(this.$itmStore.trialTypes.length < 1){
        this.loadTrialTypes()
        console.log(this.$itmStore)
      }

    },
    doLogIn(e) {
      e.preventDefault()
      if (this.pwd.length > 0) {
        this.$http.post(this.$remote + '/api/usr', {
          who: this.email,
          pw: this.pwd
        })
            .then(response => {
              this.$initFromToken(response.data.token)
              let isAdmin = this.$hasRole(['adm','sys'])
              const daysTilExp = response.data.daysUntilExpires
              const toRenew = response.data.toRenew
              const memberSince = response.data.user.memberSince
              this.$usrStore.toRenew = Object.assign(this.$usrStore.toRenew, toRenew)
              this.$usrStore.memberSince = memberSince
              if(memberSince == null) {
//                window.location.assign(`https://api.acsw.com.au/w3/n/${this.$UUIDv4()}/${this.$usrStore.mNbr}`)
                window.location.assign(`${this.$express}/w3/n/${this.$UUIDv4()}/${this.$usrStore.mNbr}`)
                return
              }
              if ((daysTilExp < 30) && (daysTilExp > 0)){
                if(confirm("Your membership is due for renewal in " + daysTilExp + " days\n" +
                "Do you want to take care of that now?")) {
                  window.location.assign(`${this.$express}/w3/p/${this.$UUIDv4()}/${this.$usrStore.mNbr}`)
                  return
                }
                // alert ("You are due for renewal in " + daysTilExp + " days")
              }
              if (daysTilExp < 0) {
                let msg = `You are ${(0 - daysTilExp)} days past due for renewal\n`
                msg += `If you renew today, the fees to rejoin will be as follows:\n`
                msg += `Rejoining fee: ${toRenew.rejoinFee}\n`
                msg += `Renewal fee: ${toRenew.renewFee}\n`
                msg += `Total fee to rejoin and renew: AUD ${toRenew.rejoinFee + toRenew.renewFee}\n`
                msg += `The renewal will be be valid until ${this.$iso2AU(toRenew.newRenewDate)}`
                alert (msg)
                window.location.assign(`${this.$express}/w3/p/${this.$UUIDv4()}/${this.$usrStore.mNbr}`)
                return
              }
              //if (this.$usrStore.token != null) {
              if (this.$isTokenCurrent()) {
                this.$emit('loggedIn')
                if (this.$route.params.nextUrl != null) {
                  this.$router.push(this.$route.params.nextUrl)
                } else {
                  this.loadStuff()
                  if (isAdmin) {
                    this.$router.push('members')
                  } else {
                    this.$router.push('member')
                  }
                }
              } else {
                this.$router.push('login')
              }
            })
            .catch(function (error) {
              if(error.response.status==418){
                alert(error.response.data.message)
              } else {
                alert(error.response.data.message)
              }
            })
      }
    },
    parseJwt(token) {
      try {
        return JSON.parse(atob(token.split('.')[1]))
      } catch (e) {
        return null
      }
    }
  },
  computed: {
    pwdSame() {
      return this.nm_pwd===this.vpwd
    },
    capSame() {
      return this.nm_pwd===this.vpwd
    },
    loginMsg() {
      return ''

    }
  },
}
</script>

<style scoped>
.compact {
  padding-top: 0px;
  margin-top: 0px;
}
</style>
